import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { DataProvider } from './store/DataContext';
import { Login } from './pages/Login';
import { DashboardLayout } from './components/layout/DashboardLayout';
import { DashboardRouter } from './pages/DashboardRouter';
import { PatientFiles } from './pages/admin/PatientFiles';
import { StaffManagement } from './pages/admin/StaffManagement';
import { ActivityLog } from './pages/admin/ActivityLog';
import { MaternityFiles } from './pages/maternity/MaternityFiles';
import { BillingModule } from './pages/billing/BillingModule';
export function App() {
  return <DataProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/login" element={<Login data-id="element-4" />} data-id="element-3" />
          <Route path="/dashboard" element={<DashboardLayout data-id="element-6" />} data-id="element-5">
            <Route index element={<DashboardRouter data-id="element-8" />} data-id="element-7" />
            <Route path="patients" element={<PatientFiles data-id="element-10" />} data-id="element-9" />
            <Route path="maternity" element={<MaternityFiles data-id="element-12" />} data-id="element-11" />
            <Route path="billing" element={<BillingModule data-id="element-14" />} data-id="element-13" />
            <Route path="staff" element={<StaffManagement data-id="element-16" />} data-id="element-15" />
            <Route path="activity-log" element={<ActivityLog data-id="element-18" />} data-id="element-17" />
          </Route>
          <Route path="/" element={<Navigate to="/dashboard" replace data-id="element-20" />} data-id="element-19" />
        </Routes>
      </BrowserRouter>
    </DataProvider>;
}